import { render, staticRenderFns } from "./dougong-pay-config.vue?vue&type=template&id=789113ec&scoped=true"
import script from "./dougong-pay-config.vue?vue&type=script&lang=js"
export * from "./dougong-pay-config.vue?vue&type=script&lang=js"
import style0 from "./dougong-pay-config.vue?vue&type=style&index=0&id=789113ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789113ec",
  null
  
)

export default component.exports